import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { LK_ROADMAPS_EXPERTS_ROUTES as ROUTES } from './utils'
import { lkStoreModule } from '@/store/modules/lk'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'roadmaps-experts',
    name: ROUTES.LAYOUT,
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      // const { registerModule } = await import(
      //   /* webpackChunkName: "roadmaps-lk-feed.store" */
      //   './store'
      // )
      // registerModule(options)

      const storeModule = lkStoreModule.context(options.store)

      const promises = [
        storeModule.actions.getTopics().catch(() => ({})),
        storeModule.actions.getRoadmapsCount().catch(() => ({})),
        storeModule.actions.getMunMehCount().catch(() => ({})),
      ]

      await Promise.all(promises)

      next()
    },
    component: (): PromiseVue => import(
      /* webpackChunkName: "roadmaps-lk-experts.layout" */
      './LKRoadmapsExpertsView.vue'
    ),
    children: [
      {
        path: ':id',
        name: ROUTES.LAYOUT_READONLY,
        component: (): PromiseVue => import(
          /* webpackChunkName: "roadmaps-lk-experts.layout.readonly" */
          './LKRoadmapsExpertsView.vue'
        ),
      },
    ],
  },
]

const createModule = (options: Options) => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
